import { createFileRoute, Link } from "@tanstack/react-router";
import { EmphasizedTitle } from "@/components/site/EmphasizedTitle";
import { pageHead } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";
import { ArrowRight } from "lucide-react";

export const Route = createFileRoute("/lessons")({
  head: () =>
    pageHead({
      title: m.lessons_meta_title(),
      description: m.lessons_meta_description(),
      path: "/lessons",
    }),
  component: LessonsPage,
});

function getFormats() {
  return [
    {
      n: "01",
      title: m.lessons_format_private_title(),
      duration: m.lessons_format_private_duration(),
      body: m.lessons_format_private_body(),
    },
    {
      n: "02",
      title: m.lessons_format_playing_title(),
      duration: m.lessons_format_playing_duration(),
      body: m.lessons_format_playing_body(),
    },
    {
      n: "03",
      title: m.lessons_format_video_title(),
      duration: m.lessons_format_video_duration(),
      body: m.lessons_format_video_body(),
    },
    {
      n: "04",
      title: m.lessons_format_junior_title(),
      duration: m.lessons_format_junior_duration(),
      body: m.lessons_format_junior_body(),
    },
  ];
}

function LessonsPage() {
  const formats = getFormats();

  return (
    <>
      <section className="bg-ink">
        <div className="container-page page-hero-pad">
          <span className="eyebrow">{m.lessons_eyebrow()}</span>
          <h1 className="mt-3 max-w-3xl font-display text-hero leading-[0.95] md:text-8xl">
            <EmphasizedTitle
              lead={m.lessons_title_lead()}
              accent={m.lessons_title_accent()}
              stacked
            />
          </h1>
          <p className="mt-6 max-w-2xl text-foreground/80">{m.lessons_intro()}</p>
        </div>
      </section>

      <section className="container-page page-follow-pad">
        <div className="grid gap-px bg-white/10 md:grid-cols-2">
          {formats.map((f) => (
            <div key={f.n} className="bg-ink p-10">
              <div className="font-display text-6xl text-ember">{f.n}</div>
              <div className="mt-5 flex items-baseline justify-between gap-4">
                <h2 className="font-display text-3xl">{f.title}</h2>
                <span className="font-display text-xs tracking-[0.18em] text-foreground/60">
                  {f.duration}
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground/75">{f.body}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 flex flex-wrap items-center justify-between gap-4 border border-white/10 bg-black/40 p-9">
          <div>
            <h3 className="font-display text-3xl">{m.lessons_practice()}</h3>
            <p className="mt-2 text-sm text-foreground/70">{m.lessons_practice_hint()}</p>
          </div>
          <Link
            to="/practice"
            className="inline-flex items-center gap-2 border border-white/30 px-5 py-3 font-display text-sm tracking-[0.15em] hover:bg-white/5"
          >
            {m.lessons_practice_cta()} <ArrowRight className="h-5 w-5 rtl:rotate-180" />
          </Link>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-between gap-4 border border-white/10 bg-black/40 p-9">
          <div>
            <h3 className="font-display text-3xl">{m.lessons_ready()}</h3>
            <p className="mt-2 text-sm text-foreground/70">{m.lessons_ready_hint()}</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/schedule" className="btn-ember btn-ember-hover">
              {m.lessons_book()} <ArrowRight className="h-5 w-5 rtl:rotate-180" />
            </Link>
            <Link
              to="/prices"
              className="inline-flex items-center gap-2 border border-white/30 px-5 py-3 font-display text-sm tracking-[0.15em] hover:bg-white/5"
            >
              {m.lessons_see_pricing()}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
